export class RehearsalSceneItem {
    public id: number = 0;
    public name: string = '';
    public notes: string = '';
    public required: boolean = false;

    public create(json: any): RehearsalSceneItem {
        if (json == null) {
            throw Error('No json provided');
        }

        const entity = new RehearsalSceneItem();
        entity.id = json.id;
        entity.name = json.name;
        entity.notes = json.notes;
        entity.required = json.required ?? false;

        return entity;
    }

}
